import { z } from 'zod';
import { requiredString } from '../helpers';
export const Amazon_Connect_Update_Contact_Attributes_1_ConfigValidator = z
    .object({
    instanceId: requiredString('Amazon Connect Connection is required'),
    contactId: z.string().optional(),
    phoneNumber: z.string().optional(),
    attributes: z.record(z.string(), z.string()).default({})
})
    .refine((data) => data.contactId || data.phoneNumber, {
    path: ['lookupMethod'],
    error: 'Either phone number or Contact ID must be provided'
});
//# sourceMappingURL=amazon-connect-update-contact-attributes-1.js.map